import { render, staticRenderFns } from "./MiniWizardExpandable.vue?vue&type=template&id=4104e838"
import script from "./MiniWizardExpandable.vue?vue&type=script&lang=js"
export * from "./MiniWizardExpandable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports